/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  DirectionData,
  Paises,
  TiposDocumentoKosmos,
  TiposVia,
} from '../../../types/PersonalData';
import { MisDatosHelper } from '../MisDatosHelper';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import { DirectionsHelper } from '../DirectionsHelper';
import IconChat from '../../../Icons/IconChat';

interface Props {
  directionData: DirectionData;
  isParticular: boolean;
  updateDireccion: () => void;
  handleChange: (key: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  tiposDocumento: TiposDocumentoKosmos[];
  tiposVia: TiposVia[];
  paises: Paises[];
  manageProvinceByCP: (postalCode: string, id: string) => void;
  isAdd: boolean;
}

const FacturacionParticularForm: FC<Props> = (props) => {
  const {
    directionData,
    isParticular,
    updateDireccion,
    handleChange,
    handleChangeSelect,
    tiposDocumento,
    tiposVia,
    paises,
    manageProvinceByCP,
    isAdd,
  } = props;
  const { t } = useTranslation();
  const { register, handleSubmit, errors, triggerValidation } = useForm({
    mode: 'onChange',
  });
  const [tipoDocumentoCambiado, setTipoDocumentoCambiado] = useState(
    false as boolean,
  );
  const [errorPostal, setErrorPostal] = useState('' as string);
  const misDatosHelper = new MisDatosHelper();
  const ID_ESPAÑA_STR = 'es' as string;

  const [visible, setVisible] = useState<boolean>(false);

  const validarTipoVia = (value: any) => {
    return value !== '0';
  };

  const getTipoDniSelectValue = () => {
    const tipoDniSelect = document.getElementById(
      `tipo-dni-factu-${directionData.idDireccion}`,
    ) as HTMLSelectElement;
    return tipoDniSelect?.value as string;
  };

  const validarTipoDni = (value: any) => {
    const tipoDocKosmos = getTipoDniSelectValue();
    directionData.tipoDocKosmos = tipoDocKosmos;
    return misDatosHelper.validarTipoDni(
      value,
      misDatosHelper.transformarTipoDocKosmosANumber(tipoDocKosmos),
    );
  };

  const validarRequerimientoCodigoPostal = (
    postalValue: string,
    isPassport: boolean,
  ) => {
    let valid = false;
    if (isPassport) {
      valid = true;
    } else {
      if (
        postalValue !== undefined &&
        postalValue !== null &&
        postalValue.length > 0
      ) {
        valid = true;
      }
    }
    return valid;
  };

  const validarCodigoPostal = (postalInput: string, isPassport: boolean) => {
    let validResult;
    const expRegCodPosSpain = new RegExp(
      /^(?:0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-2])([0-9]{3})$/,
    );
    const expRegCodPosOthers = new RegExp(/^[0-9]{1,6}$/);
    if (postalInput !== undefined && postalInput.length > 0) {
      // eslint-disable-next-line no-lonely-if
      if (isPassport) {
        validResult = expRegCodPosOthers.test(postalInput);
      } else {
        validResult = expRegCodPosSpain.test(postalInput);
      }
    } else {
      validResult = true;
    }
    return validResult;
  };

  const isValidCodigoPostal = () => {
    const isPassport = (getTipoDniSelectValue() ===
      MisDatosConstants.TIPO_DOC_PASAPORTE_KOSMOS) as boolean;
    const postalInput = document.getElementById(
      `cod-factu-${directionData.idDireccion}`,
    ) as HTMLInputElement;
    const validRequire = validarRequerimientoCodigoPostal(
      postalInput?.value,
      isPassport,
    );
    const validFormat = validarCodigoPostal(postalInput?.value, isPassport);
    if (!validRequire) {
      setErrorPostal('required');
      postalInput?.classList.add('error');
    } else if (!validFormat) {
      setErrorPostal('format');
      postalInput?.classList.add('error');
    } else {
      setErrorPostal('');
      postalInput?.classList.remove('error');
    }
    return validRequire && validFormat;
  };

  const manageProvinceByCPIfNeeded = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (
      getTipoDniSelectValue() !== MisDatosConstants.TIPO_DOC_PASAPORTE_KOSMOS
    ) {
      manageProvinceByCP(
        e.target.value,
        `provincia-factu-${directionData.idDireccion}`,
      );
    }
  };

  const gestionesCuandoEsPasaporte = (
    paisSelect: HTMLSelectElement,
    deleteableElement: HTMLCollectionOf<Element>,
    spainOptionIndex: number,
    codInput: HTMLInputElement,
  ) => {
    paisSelect.removeAttribute('disabled');
    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < deleteableElement.length; x++) {
      deleteableElement[x].classList.add('hidden');
    }
    // eslint-disable-next-line no-param-reassign
    paisSelect.selectedIndex = 0;
    paisSelect.dispatchEvent(new Event('change', { bubbles: true }));
    // eslint-disable-next-line no-unused-expressions
    paisSelect.item(spainOptionIndex)?.setAttribute('hidden', 'hidden');
    codInput.setAttribute(
      'maxLength',
      `${MisDatosConstants.MAX_LENGTH_DIR_FAC_DOC}`,
    );
  };

  const gestionescuandoNOEsPasaporte = (
    paisSelect: HTMLSelectElement,
    deleteableElement: HTMLCollectionOf<Element>,
    spainOptionIndex: number,
  ) => {
    paisSelect.setAttribute('disabled', 'disabled');
    // eslint-disable-next-line no-param-reassign
    paisSelect.selectedIndex = spainOptionIndex;
    paisSelect.dispatchEvent(new Event('change', { bubbles: true }));
    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < deleteableElement.length; x++) {
      deleteableElement[x].classList.remove('hidden');
    }
    const postalCodeInput = document.getElementById(
      `cod-factu-${directionData.idDireccion}`,
    ) as HTMLInputElement;
    manageProvinceByCP(
      postalCodeInput.value,
      `provincia-factu-${directionData.idDireccion}`,
    );
  };

  const crearEventoChangeConValor = (valor: string) => {
    const e = (new Event('change', {
      bubbles: true,
    }) as unknown) as React.ChangeEvent<HTMLSelectElement>;
    const data = ({
      value: valor,
    } as unknown) as EventTarget & HTMLSelectElement;
    Object.defineProperty(e, 'target', { writable: false, value: data });
    return e;
  };

  useEffect(() => {
    const paisSelect = document.getElementById(
      `country-part-factu-${directionData.idDireccion}`,
    ) as HTMLSelectElement;
    const codInput = document.getElementById(
      `dni-factur-${directionData.idDireccion}`,
    ) as HTMLInputElement;
    const spainOptionIndex = DirectionsHelper.getSpainOptionIndexValue(
      paisSelect,
    ) as number;
    const deleteableElement = document.getElementsByClassName('no-passport');
    const tipoDoc = getTipoDniSelectValue() as string;
    if (tipoDoc === MisDatosConstants.TIPO_DOC_PASAPORTE_KOSMOS) {
      gestionesCuandoEsPasaporte(
        paisSelect,
        deleteableElement,
        spainOptionIndex,
        codInput,
      );
    } else {
      gestionescuandoNOEsPasaporte(
        paisSelect,
        deleteableElement,
        spainOptionIndex,
      );
    }
  }, [tipoDocumentoCambiado]);

  useEffect(() => {
    let e;
    if (directionData.tipoDocKosmos && directionData.tipoDocKosmos.length > 0) {
      e = crearEventoChangeConValor(directionData.tipoDocKosmos);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (isParticular) {
        e = crearEventoChangeConValor(MisDatosConstants.TIPO_DOC_DNI_KOSMOS);
      } else {
        e = crearEventoChangeConValor(MisDatosConstants.TIPO_DOC_CIF_KOSMOS);
      }
    }
    handleChangeSelect('tipoDocKosmos', e);
  }, [isParticular]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.getElementById('form-particular') as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('fact-particular-btn').click();
      setVisible(false);
    }
  };
  useEffect(() => {
    if (visible) {
      const element = document.getElementById('form-particular') as HTMLElement;

      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    }
  }, [visible]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const isVisible = document
      .querySelector('section.o-section--large.form-facturacion.bloque-form')
      .classList.contains('visible');
    if (isVisible) setVisible(true);
  });

  return (
    <>
      {/* <div className="container"> */}
      <form
        id="form-particular"
        className={`form-edit-facturacion ${isParticular ? 'visible' : ''}`}
        noValidate
        onSubmit={handleSubmit(() => {
          if (isValidCodigoPostal()) {
            updateDireccion();
          }
        })}
      >
        <div className="row u-margin-bottom">
          <div className="col-12 col-md-4">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="dni-factur" className="control-label">
                {t('datos.directions.ci')}
              </label>
              <div className="u-display-flex">
                <div className="form-control-block form-control--compound form-docType">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label className="hidden" htmlFor="tipo-dni-factu">
                    Tipo de documento
                  </label>
                  <select
                    className="form-control select-dni"
                    id={`tipo-dni-factu-${directionData.idDireccion}`}
                    onChange={(e) => {
                      handleChangeSelect('tipoDocKosmos', e);
                      setTipoDocumentoCambiado(!tipoDocumentoCambiado);
                      isValidCodigoPostal();
                      triggerValidation('nif');
                    }}
                  >
                    {tiposDocumento.map((tip) =>
                      tip.idDocumento !==
                      MisDatosConstants.TIPO_DOC_CIF_KOSMOS ? (
                        <option
                          key={tip.idDocumento}
                          selected={
                            directionData.tipoDocKosmos &&
                            directionData.tipoDocKosmos.length > 0
                              ? tip.idDocumento === directionData.tipoDocKosmos
                              : tip.idDocumento ===
                                MisDatosConstants.TIPO_DOC_DNI_KOSMOS
                          }
                          value={tip.idDocumento}
                        >
                          {tip.documento}
                        </option>
                      ) : (
                        ''
                      ),
                    )}
                  </select>
                  <div className="icon icon-small">
                    <IconChat />
                  </div>
                </div>
                <div className="form-control input-select">
                  <input
                    type="text"
                    className={`form-control ${errors.nif ? 'error' : ''}`}
                    name="nif"
                    id={`dni-factur-${directionData.idDireccion}`}
                    maxLength={MisDatosConstants.MAX_LENGTH_DIR_FAC_DOC}
                    defaultValue={directionData.numDoc}
                    onChange={(e) => handleChange('ci', e)}
                    ref={register({
                      required: true,
                      validate: (value) => validarTipoDni(value),
                    })}
                  />
                  {errors.nif && errors.nif.type === 'required' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label id="nif-error" className="error" htmlFor="nif">
                      {t('validaciones.empty-value')}
                    </label>
                  )}
                  {errors.nif && errors.nif.type === 'validate' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label id="nif-error" className="error" htmlFor="nif">
                      {t('validaciones.not-valid-format')}
                    </label>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row u-margin-bottom">
          <div className="col-12 col-md-4">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="nombreFacturacion" className="control-label">
                {t('datos.directions.name')}{' '}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className={`form-control ${
                    errors.nombreFacturacion ? 'error' : ''
                  }`}
                  name="nombreFacturacion"
                  id={`nombre-facturacion-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_NOMBRE}
                  defaultValue={directionData.nombre}
                  onChange={(e) => handleChange('nombre', e)}
                  ref={register({
                    required: true,
                    pattern: /^[A-Z\s]+$/i,
                  })}
                />
                {errors.nombreFacturacion &&
                  errors.nombreFacturacion.type === 'required' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label
                      id="nombreFacturacion-error"
                      className="error"
                      htmlFor="nombreFacturacion"
                    >
                      {t('validaciones.empty-value')}
                    </label>
                  )}
                {errors.nombreFacturacion &&
                  errors.nombreFacturacion.type === 'pattern' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label
                      id="nombreFacturacion-error"
                      className="error"
                      htmlFor="nombreFacturacion"
                    >
                      {t('validaciones.not-valid-value')}
                    </label>
                  )}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="apellido">
                {t('datos.directions.lastName')}
              </label>
              <input
                type="text"
                className={`form-control ${errors.apellido ? 'error' : ''}`}
                name="apellido"
                id={`apellido-${directionData.idDireccion}`}
                maxLength={MisDatosConstants.MAX_LENGTH_APELLIDO_1}
                defaultValue={directionData.apellido1}
                onChange={(e) => handleChange('primApellido', e)}
                ref={register({
                  required: true,
                })}
              />
              {errors.apellido && errors.apellido.type === 'required' && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label id="apellido-error" className="error" htmlFor="apellido">
                  {t('validaciones.empty-value')}
                </label>
              )}
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="apellido2">
                {t('datos.directions.secLastName')}
              </label>
              <input
                type="text"
                className="form-control"
                name="apellido2"
                id={`apellido2-${directionData.idDireccion}`}
                maxLength={MisDatosConstants.MAX_LENGTH_APELLIDO_2}
                defaultValue={directionData.apellido2}
                onChange={(e) => handleChange('segApellido', e)}
              />
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="codFactu" className="control-label">
                {t('datos.directions.postalCode')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className="form-control"
                  id={`cod-factu-${directionData.idDireccion}`}
                  name="codFactu"
                  maxLength={MisDatosConstants.MAX_LENGTH_COD_POSTAL_DIR_FAC}
                  defaultValue={directionData.postalCode}
                  onChange={(e) => {
                    handleChange('postalCode', e);
                    manageProvinceByCPIfNeeded(e);
                    isValidCodigoPostal();
                  }}
                />
                {errorPostal && errorPostal === 'required' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="codFactu-error"
                    className="error"
                    htmlFor="codFactu"
                  >
                    {t('validaciones.empty-value')}
                  </label>
                )}
                {errorPostal && errorPostal === 'format' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="codFactu-error"
                    className="error"
                    htmlFor="codFactu"
                  >
                    {t('validaciones.not-valid-format')}
                  </label>
                )}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="locaFactu">
                {t('datos.directions.locality')}
              </label>
              <input
                type="text"
                name="locaFactu"
                className={`form-control ${errors.locaFactu ? 'error' : ''}`}
                id={`locaFactu-${directionData.idDireccion}`}
                maxLength={MisDatosConstants.MAX_LENGTH_LOCALIDAD_DIR_FAC}
                onChange={(e) => handleChange('localidad', e)}
                defaultValue={directionData.locality}
                ref={register({
                  required: true,
                })}
              />
              {errors.locaFactu && errors.locaFactu.type === 'required' && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label
                  id="locaFactu-error"
                  className="error"
                  htmlFor="locaFactu"
                >
                  {t('validaciones.empty-value')}
                </label>
              )}
            </div>
          </div>
          <div className="col-12 col-md-2">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="tipo-via-factu">
                {t('datos.directions.roadType')}
              </label>
              <div className="form-control-block">
                <select
                  className={`form-control valid ${
                    errors.tipoVia ? 'error' : ''
                  }`}
                  name="tipoVia"
                  id={`tipo-via-part-factu-${directionData.idDireccion}`}
                  onChange={(e) => handleChangeSelect('tipoVia', e)}
                  ref={register({
                    validate: (value) => validarTipoVia(value),
                  })}
                >
                  <option value={0}>{t('datos.directions.roadType')}</option>
                  {tiposVia.map((via) => (
                    <option
                      key={via.idTipoVia}
                      selected={via.idTipoVia === directionData.roadType}
                      value={via.idTipoVia}
                    >
                      {via.nombreTipoVia}
                    </option>
                  ))}
                </select>
                <div className="icon icon-small">
                  <IconChat />
                </div>
                {errors.tipoVia && errors.tipoVia.type === 'validate' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label id="tipoVia-error" className="error" htmlFor="tipoVia">
                    {t('validaciones.empty-value')}
                  </label>
                )}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="via-factu" className="control-label">
                {t('datos.directions.roadName')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className={`form-control ${errors.viaFactu ? 'error' : ''}`}
                  name="viaFactu"
                  id={`via-factu-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_NOMBRE_DE_VIA}
                  defaultValue={directionData.roadName}
                  onChange={(e) => handleChange('roadName', e)}
                  ref={register({
                    required: true,
                  })}
                />
                {errors.viaFactu && errors.viaFactu.type === 'required' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="viaFactu-error"
                    className="error"
                    htmlFor="viaFactu"
                  >
                    {t('validaciones.empty-value')}
                  </label>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 col-md-1">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="numFactu" className="control-label">
                {t('datos.directions.number')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className={`form-control ${errors.numFactu ? 'error' : ''}`}
                  name="numFactu"
                  maxLength={MisDatosConstants.MAX_LENGTH_NUMERO}
                  id={`num-factu-${directionData.idDireccion}`}
                  defaultValue={directionData.number}
                  onChange={(e) => handleChange('number', e)}
                  ref={register({
                    required: true,
                    pattern: /^[0-9]+$/i,
                  })}
                />
                {errors.numFactu && errors.numFactu.type === 'required' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="numFactu-error"
                    className="error"
                    htmlFor="numFactu"
                  >
                    {t('validaciones.empty-value')}
                  </label>
                )}
                {errors.numFactu && errors.numFactu.type === 'pattern' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="numFactu-error"
                    className="error"
                    htmlFor="numFactu"
                  >
                    {t('validaciones.not-valid-value')}
                  </label>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 col-md-1">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="portal-factu" className="control-label">
                {t('datos.directions.portal')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className="form-control"
                  name="portal-factu"
                  maxLength={MisDatosConstants.MAX_LENGTH_PORTAL}
                  id={`portal-factu-${directionData.idDireccion}`}
                  defaultValue={directionData.portal}
                  onChange={(e) => handleChange('portal', e)}
                />
              </div>
            </div>
          </div>
          <div className="col-4 col-md-1">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="escalera-factu" className="control-label">
                {t('datos.directions.stairs')}
              </label>
              <div className="form-control-block" />
              <input
                type="text"
                className="form-control"
                name="escalera-factu"
                maxLength={MisDatosConstants.MAX_LENGTH_ESCALERA}
                id={`escalera-factu-${directionData.idDireccion}`}
                defaultValue={directionData.stairs}
                onChange={(e) => handleChange('stairs', e)}
              />
            </div>
          </div>
          <div className="col-4 col-md-1">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="piso-factu" className="control-label">
                {t('datos.directions.floor')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className="form-control"
                  name="piso-factu"
                  maxLength={MisDatosConstants.MAX_LENGTH_PISO}
                  id={`piso-factu-${directionData.idDireccion}`}
                  defaultValue={directionData.floor}
                  onChange={(e) => handleChange('floor', e)}
                />
              </div>
            </div>
          </div>
          <div className="col-4 col-md-1">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="puerta-factu" className="control-label">
                {t('datos.directions.door')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className="form-control"
                  name="puerta-factu"
                  maxLength={MisDatosConstants.MAX_LENGTH_PUERTA}
                  id={`puerta-factu-${directionData.idDireccion}`}
                  defaultValue={directionData.door}
                  onChange={(e) => handleChange('door', e)}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 no-passport">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="provincia-factu">
                {t('datos.directions.province')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className="form-control"
                  name="provincia-factu"
                  id={`provincia-factu-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_PROVINCIA_DIR_FAC}
                  disabled
                  defaultValue={directionData.province}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label" htmlFor="country-factu">
                {t('datos.directions.country')}
              </label>
              <div className="form-control-block">
                <select
                  className="form-control"
                  id={`country-part-factu-${directionData.idDireccion}`}
                  onChange={(e) => handleChangeSelect('pais', e)}
                  disabled
                >
                  {paises.map((p) => (
                    <option
                      key={p.id}
                      selected={
                        directionData.country &&
                        directionData.country.length > 0
                          ? p.id === directionData.country
                          : p.id === ID_ESPAÑA_STR
                      }
                      value={p.id}
                    >
                      {p.pais}
                    </option>
                  ))}
                </select>
                <div className="icon icon-small">
                  <IconChat />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4">
            <div className="form-group u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="nameFactu" className="control-label">
                {t('datos.directions.directionName')}
              </label>
              <div className="form-control-block">
                <input
                  type="text"
                  className={`form-control ${errors.nameFactu ? 'error' : ''}`}
                  name="nameFactu"
                  id={`name-factu-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_NOMBRE_DIRECCION}
                  defaultValue={directionData.directionName}
                  onChange={(e) => handleChange('directionName', e)}
                  ref={register({
                    required: true,
                  })}
                />
                {errors.nameFactu && errors.nameFactu.type === 'required' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    id="nameFactu-error"
                    className="error"
                    htmlFor="nameFactu"
                  >
                    {t('validaciones.empty-value')}
                  </label>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="u-text-right">
          <button
            id="fact-particular-btn"
            type="submit"
            className="btn btn-primary "
          >
            {isAdd ? t('datos.directions.add') : t('datos.directions.update')}
          </button>
        </div>
      </form>
      {/* </div> */}
    </>
  );
};

export default FacturacionParticularForm;
